import * as t from "io-ts";
import { TUserCaseUserType, UserCaseUserType } from "../codecs/UserCaseUserType";

const isUserCaseUserType = (value: string): value is TUserCaseUserType =>
    UserCaseUserType.values.some((knownValue) => knownValue === value);

const userCaseUserType = new t.Type<TUserCaseUserType, string, unknown>(
    "UserCaseUserType",
    (u): u is TUserCaseUserType => typeof u === "string" && isUserCaseUserType(u),
    (u, c) => typeof u === "string" && isUserCaseUserType(u) ? t.success(u) : t.failure(u, c),
    t.identity,
);

export const codec = t.type({
    user_id: t.string,
    user_type: userCaseUserType,
});

export type T = t.TypeOf<typeof codec>;

export const newDefault = (): T => ({
    user_id: "",
    user_type: "unknown",
});
